import ViewPromiseTemplate from './../../../promise/promiseList/viewPromise.modal.html';
import { sortBy as _sortBy } from 'lodash';
import { reverse as _reverse } from 'lodash';

class ContactPromisesController {
  constructor(promiseService, $uibModal, $scope, addPromiseService) {
    "ngInject";

    this.promiseService = promiseService;
    this.$uibModal = $uibModal;
    this.$scope = $scope;
    this.addPromiseService = addPromiseService;
  }

  complete(addAnother) {
    const ctrl = this;

    let sure = window.confirm('Are you sure you want to complete this promise');

    if (!sure) {
      return;
    }

    ctrl.promiseService.complete(this.selectedPromise.promiseId, this.tempComments)
      .finally(() => {
        ctrl.selectedPromise.completed = new Date();
        ctrl.selectedPromise.comments = this.tempComments;
        ctrl.closeModal();
        if (addAnother){
          ctrl.showAddPromise();
        }
        ctrl.listPromises();        
      })
  }

  closeModal() {
    const ctrl = this;

    if (ctrl.modalInstance) {
      ctrl.modalInstance.close();
    }
  }

  viewPromise(promise) {
    this.errMsg = '';
    this.tempComments = '';
    this.selectedPromise = promise;
    this.modalInstance = this.$uibModal.open({
        template: ViewPromiseTemplate,
        scope: this.$scope
    });
  }

  completePromise(addAnother) {
    if (!this.tempComments) {
      this.errMsg = "Please enter some comments first";
      return;
    }

    this.complete(addAnother);
  }

  showAddPromise() {
    this.addPromiseService.showAddPromise(this.addPromise.bind(this), false, '', {contactId: this.contact.contactId, contactName: this.contact.contactName}, true);
  }

  addPromise(promise) {    
    this.promises.push(promise);
    this.promises = _reverse(_sortBy(this.promises, 'dueDate'));
  }  
}

export default ContactPromisesController;



// WEBPACK FOOTER //
// ./client/app/components/contact/contactView/contactPromises/contactPromises.controller.js